import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import slide_1 from "../../fifthAssets/Images/slide-1.jpg";
import slide_2 from "../../fifthAssets/Images/slide-2.jpg";
import slide_3 from "../../fifthAssets/Images/slide-3.jpg";
import slide_4 from "../../fifthAssets/Images/slide-4.jpg";
import slide_5 from "../../fifthAssets/Images/slide-5.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function ImageSlider(props) {
    const { selectedLanguage } = props;

    const CustomNextArrow = ({ onClick }) => (
        <div className="fifth-des-custom-arrow fifth-des-next" onClick={onClick}>
            <FaChevronRight />
        </div>
    );

    const CustomPrevArrow = ({ onClick }) => (
        <div className="fifth-des-custom-arrow fifth-des-prev" onClick={onClick}>
            <FaChevronLeft />
        </div>
    );

    const settings = {
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />
    };

    return (
        <div className="fifth-des-slider-container">
            <Slider {...settings}>
                <div className="fifth-des-img-slider">
                    <img src={slide_1} alt="img" />
                    <h1>
                        {selectedLanguage?.txt_great_hospitality}
                    </h1>
                </div>
                <div className="fifth-des-img-slider">
                    <img src={slide_2} alt="img" />
                    <h1>
                        {selectedLanguage?.txt_visiting_doctors}
                    </h1>
                </div>
                <div className="fifth-des-img-slider">
                    <img src={slide_3} alt="img" />
                    <h1>
                        {selectedLanguage?.txt_second_opinion_holland}
                    </h1>
                </div>
                <div className="fifth-des-img-slider">
                    <img src={slide_4} alt="img" />
                    <h1>
                        {selectedLanguage?.txt_your_health_is_in_your_hands}
                    </h1>
                </div>
                <div className="fifth-des-img-slider">
                    <img src={slide_5} alt="img" />
                    <h1>
                        {selectedLanguage?.txt_highly_trained_staff}
                    </h1>
                </div>
            </Slider>
        </div>
    );
}

export default ImageSlider;
